<template>

    <form ref="questaotagjobs-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="tagJobsId">Selecione a tag</label>
                <select v-select="{ dataitem: 'TagJobs', default: 'Selecione', notcache: true }" v-model="model.tagJobsId" class="form-control" name="tagJobsId" required></select>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questaotagjobs-form-create",
        props: { questaoId: Number },
        mixins: [base],
        data: () => ({

            model: {
                tagJobsId: ""
            },

            form: "questaotagjobs-form-create",

            resources: {
                create: 'questaotagjobs',
            },

        }),

        methods: {

            executeCreate: function (model) {

                model.questaoId = this.questaoId;

                if (this.formValidate() == false) return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

